// DESCRIPTION: Error state component with message display
// and retry button for failed event loading.

import { __ } from '@wordpress/i18n';

const ErrorState = ( { message, onRetry } ) => {
	return (
		<div className="nb-text-center nb-py-12">
			<div className="nb-w-12 nb-h-12 nb-mx-auto nb-mb-4 nb-rounded-full nb-bg-red-50 nb-flex nb-items-center nb-justify-center">
				<svg
					className="nb-w-6 nb-h-6 nb-text-red-500"
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
				>
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={ 2 }
						d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
					/>
				</svg>
			</div>
			<p className="nb-text-gray-600 nb-mb-4">{ message }</p>
			<button className="nemtly-button-primary" onClick={ onRetry }>
				{ __( 'Try Again', 'nemtly-booking' ) }
			</button>
		</div>
	);
};

export default ErrorState;
